import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type PartialDialogProps} from 'web-app/react/dialog/types';

const domain = 'LESSON_PLANS';

export const {
    action: editLessonPlan,
    success: editLessonPlanSuccess,
    failed: editLessonPlanFailed,
} = createAction(`${domain}/EDIT`, () => ({}));

export const {
    action: republishLessonPlan,
    success: republishLessonPlanSuccess,
    failed: republishLessonPlanFailed,
    aborted: republishLessonPlanAborted,
} = createAction(`${domain}/REPUBLISH`, (payload: {dialog: PartialDialogProps}) => payload);

export const {action: lessonPlanDidChange} = createAction(
    `${domain}/LESSON_PLAN_DID_CHANGE`,
    (selectedGroupId: string, dateLocale: string | undefined) => ({selectedGroupId, dateLocale}),
);

export const {action: setSelectedDate} = createAction(`${domain}/SET_SELECTED_DATE`, (date: string) => ({date}));
export const {action: changeWeek} = createAction(`${domain}/CHANGE_WEEK`, (dateInWeek: string) => ({dateInWeek}));

export const {
    action: saveLessonPlanDraft,
    success: saveLessonPlanDraftSuccess,
    failed: saveLessonPlanDraftFailed,
} = createAction(`${domain}/SAVE_DRAFT`, (selectedGroupId: string, dateLocale: string | undefined) => ({
    selectedGroupId,
    dateLocale,
}));

export const {action: setIncludeNotVisibleToParents} = createAction(
    `${domain}/SET_INCLUDE_NOT_VISIBLE_TO_PARENTS`,
    (include: boolean) => ({include}),
);
